<template>
  <div class="myBasicsEdit">
    <div class="page-title">
      <div class="page-nav-items">
        <span class="page-parentname">基本资料></span
        ><span>粉丝量编辑</span>
      </div>
    </div>
    <div class="edit-wrap">
      <el-form :model="formData" :rules="rules" ref="editForm">
        <div class="edit-row">
          <el-form-item class="select-input" label='平台' prop="mid_table_remark_001">
            <el-select v-model="formData.mid_table_remark_001" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="offer-input" label='粉丝数量' prop="mid_table_remark_002" :rules="rules.mid_table_remark_002">
            <el-input
              class="custom-input"
              v-model="formData.mid_table_remark_002"
              placeholder="请输入粉丝数量"
              maxlength="11"
              clearable
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item class="upload-input" label='上传截图' prop="mid_table_remark_003">
          <el-upload
            class="upload-input-inner"
            action="no"
            accept=".png,.jpg,.jpeg"
            :auto-upload="false"
            :multiple="false"
            :show-file-list="false"
            :on-change="
              (file, fileList) => {
                handleChange(file, fileList, 'add');
              }
            "
          >
            <div v-if="formData.mid_table_remark_003" class="inner-text">已上传</div>
            <div v-else class="inner-icon"></div>
            <el-input style="visibility:hidden" v-model="formData.mid_table_remark_003" placeholder="请上传截图" />
          </el-upload>
          <div class="inner-tip">文件格式：png/jpg</div> 
        </el-form-item>
        <div class="edit-sure-button-wrap">
          <el-button class="edit-sure-button" @click="handleSubmit">添加</el-button>
        </div>
      </el-form>
    </div>
    <div class="tools-box">
        <div class="table-header-box cell-row">
        <div class="cell-column tasktype-cell">平台</div>
        <div class="cell-column projecttype-cell">粉丝量</div>
        <div class="cell-column project-yusuan-cell">状态</div>
        <div class="cell-column task-publishtime-cell">截图</div>
        <div class="cell-column operate-cell">操作</div>
      </div>
      <div class="table-list-box">
        <template v-if="platformList.length">
          <div v-for="(item, idx) in platformList" :key="idx" class="datalist-row cell-row">
            <div class="cell-column tasktype-cell">
              {{ optionsObj[item.mid_table_remark_001] }}
            </div>
            <div class="cell-column projecttype-cell">
              {{ item.mid_table_remark_002 }}
            </div>
            <div class="cell-column project-yusuan-cell"
            :class="item.mid_table_remark_004?'color'+item.mid_table_remark_004:'color4001'"
            >
              {{ item.mid_table_remark_004 == 4001 ? "待审核" : (item.mid_table_remark_004 == 4002 ? "通过" : "审核失败") }}
            </div>
            <div class="cell-column task-publishtime-cell">
              <el-image
                style="width: 76px; height: 76px; border-radius: 4px;"
                :src="item.mid_table_remark_003"
                fit="cover"></el-image>
            </div>
            <div class="cell-column operate-cell">
              <div class="operate-edit" @click="editItem(item)">编辑</div>
              <div class="operate-delete" @click="deleteItem(item,idx)">删除</div>
            </div>
          </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </div>
    <BasicsEdit ref="dialogBasicsEdit" :editInfo="editData" :userInfo="userInfo"></BasicsEdit>
  </div>
</template>
<script>
import { Base64 } from "js-base64";
import storage from "@/utils/customLocalStorage";
import {positiveIntegerValidator} from "@/assets/js/util";
import BasicsEdit from "@/components/dialog/BasicsEdit";
import NoneData from "@/components/NoneData";
import pageCommon from "@/utils/pagecommon";
import platformApi from "@/api/platform";
import accountApi from "@/api/account";
export default {
  name: "MyBasicsEdit",
  components: {NoneData, BasicsEdit },
  created() {
    let _this = this;
    _this.currentPage = 1;
    _this.total = 1;
    _this.isRequesting = true;
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 8);    
    _this.getPlatformList();
  },
  data() {
    return {
      showPassword: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
      isRequesting: false,
      formData: {
        mid_table_remark_001: null,
        mid_table_remark_002: null,
        mid_table_remark_003: null
      },
      editData:{},
      platformList: [],
      rules: {
        mid_table_remark_001: [
          {required: true, message: "请选择平台", trigger: "change"}
        ],
        mid_table_remark_002: [
          {required: true, message: "请填写粉丝量", trigger: "blur"},
          {validator: positiveIntegerValidator, trigger: "blur"}
        ],
        mid_table_remark_003: [
          {required: true, message: "请上传截图", trigger: "change"}
        ]
      },
      options: [
        {
          value: '1001',
          label: '知乎'
        }, {
          value: '1002',
          label: 'CSDN'
        }, {
          value: '1003',
          label: '抖音'
        }, {
          value: '1004',
          label: '快手'
        }, {
          value: '1005',
          label: '西瓜视频'
        }, {
          value: '1006',
          label: '微信视频'
        }, {
          value: '1007',
          label: 'B站'
        }, {
          value: '1008',
          label: '今日头条'
        }, {
          value: '1009',
          label: '网易新闻'
        }, {
          value: '1010',
          label: '其他'
        }
      ],
      optionsObj:{'1001':'知乎', '1002':'CSDN', '1003':'抖音', '1004':'快手', '1005':'西瓜视频', '1006':'微信视频', '1007':'B站', '1008':'今日头条', '1009':'网易新闻', '1010':'其他'}
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  methods: {
    getPlatformList: function () {
      let _this = this;
      let requestData = {
        begin_idx: 0,
        limit: 100,
        id_public_user_info: this.userInfo.id_public_user_info,
        isloading: true,
      };
      pageCommon.apiRequestCommon(platformApi, "getPlatformData", requestData).then(
        (res) => {
          console.log(res)
          this.platformList=res.page_content;
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    handleDownloadTest(){
      if(this.formData.mid_table_remark_008){
        window.open(this.formData.mid_table_remark_008);
      } else {
        this.$confirm("暂无可下载的需求包, 请联系相关人员", "提示", {
          type: "warning",
          showCancelButton: false,
        }).then(() => {});
      }
    },
    handleChange: function (file, fileList) {
      let _this = this;
      let data = this.$cookies.get("ossParams");
      if (!data) {
        _this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        _this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      _this.$uploadNormal(data, file, false).then(
        (res) => {
          this.$set(_this.formData, 'mid_table_remark_003', res)
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    handleSubmit: function () {
      let _this = this;
      _this.$refs["editForm"].validate((valid) => {
        if (valid) {
          let isExist=false;
          let existIndex='';
          let number=0;
          for (let i = 0; i < _this.platformList.length; i++) {
            if(_this.platformList[i].mid_table_remark_001==_this.formData.mid_table_remark_001){
              isExist=true;
              existIndex=i;
            }
          }
          if(!_this.sending){
            _this.sending=true;
            if(isExist){
              _this.$confirm('您已填写过此平台数据，编辑将会覆盖以往数据，是否编辑', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let requestData = {
                  id_public_middle_table: _this.platformList[existIndex].id_public_middle_table,
                  id_public_user_info: this.userInfo.id_public_user_info,
                  mid_table_remark_001: this.formData.mid_table_remark_001,
                  mid_table_remark_002: this.formData.mid_table_remark_002,
                  mid_table_remark_003: this.formData.mid_table_remark_003,
                  mid_table_remark_004: 4001,
                  isloading: true,
                };
                pageCommon.apiRequestCommon(platformApi, "insertPlatformData", requestData).then(
                  (res) => {
                    this.$set(_this.platformList, existIndex , res.page_content[0]);
                    for (let j = 0; j < _this.platformList.length; j++) {
                      if(_this.platformList[j].mid_table_remark_004==4002){
                        number=number+Number(_this.platformList[j].mid_table_remark_002)
                      }
                    }
                    let requestUserData = {
                      id_public_user_info: this.userInfo.id_public_user_info,
                      user_remark_021: number,
                      isloading: true,
                    };
                    pageCommon.apiRequestCommon(accountApi, "changeUerInfo", requestUserData).then(
                      (res) => {
                        _this.sending = false;
                        this.resetTemp();
                        _this.$store.dispatch("acUser", res.public_user_info);
                        storage.set("user", JSON.stringify(res.public_user_info));
                      },
                      (err) => {
                        _this.sending = false;
                        if (err.sysUserLoginError) {
                          _this.$message.error("系统异常，请稍后刷新重试！");
                        } else {
                          _this.$message.error(err.data.msg);
                        }
                      }
                    );
                  },
                  (err) => {
                    _this.sending = false;
                    if (err.sysUserLoginError) {
                      _this.$message.error("系统异常，请稍后刷新重试！");
                    } else {
                    }
                  }
                );
              })
              .catch(() => {
                _this.sending = false;     
              });
            } else {
              let requestData = {
                id_public_user_info: this.userInfo.id_public_user_info,
                mid_table_remark_001: this.formData.mid_table_remark_001,
                mid_table_remark_002: this.formData.mid_table_remark_002,
                mid_table_remark_003: this.formData.mid_table_remark_003,
                mid_table_remark_004: 4001,
                isloading: true,
              };
              pageCommon.apiRequestCommon(platformApi, "insertPlatformData", requestData).then(
                (res) => {
                  console.log()
                  _this.platformList.unshift(res.page_content[0]);
                  this.resetTemp()
                },
                (err) => {
                  _this.sending = false;
                  if (err.sysUserLoginError) {
                    _this.$message.error("系统异常，请稍后刷新重试！");
                  } else {
                  }
                }
              );
            }
          }
        }
      });
    },
    // 重置数据
    resetTemp() {
      this.formData = {
        mid_table_remark_001: null,
        mid_table_remark_002: null,
        mid_table_remark_003: null
      }
    },
    editItem: function(item,index){
      this.editData=item;
      this.$refs["dialogBasicsEdit"].showDialog = true;
    },
    deleteItem: function(item,index){
      let _this=this;
      let number=0;
      this.$confirm('删除后数据将无法找回，是否继续删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          id_public_middle_table: item.id_public_middle_table,
          is_online: 111,
          isloading: true,
        };
        pageCommon.apiRequestCommon(platformApi, "insertPlatformData", requestData).then(
          (res) => {
            _this.platformList.splice(index, 1);
            for (let j = 0; j < _this.platformList.length; j++) {
              if(_this.platformList[j].mid_table_remark_004==4002){
                number=number+Number(_this.platformList[j].mid_table_remark_002)
              }
            }
            let requestUserData = {
              id_public_user_info: _this.userInfo.id_public_user_info,
              user_remark_021: number,
              isloading: true,
            };
            if(item.mid_table_remark_004==4002){
              pageCommon.apiRequestCommon(accountApi, "changeUerInfo", requestUserData).then(
                (res) => {
                  _this.sending = false;
                  _this.resetTemp();
                  _this.$store.dispatch("acUser", res.public_user_info);
                  storage.set("user", JSON.stringify(res.public_user_info));
                },
                (err) => {
                  _this.sending = false;
                  if (err.sysUserLoginError) {
                    _this.$message.error("系统异常，请稍后刷新重试！");
                  } else {
                    _this.$message.error(err.data.msg);
                  }
                }
              );
            }
          },
          (err) => {
            _this.sending = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {       
      });
    }
  },
};
</script>
<style lang="less">
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.myBasicsEdit {
  position: relative;
  width: 100%;
  height: 100%;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .edit-wrap{
    position:relative;
    margin-top:40px;
    padding:32px 24px;
    background:#F6F6F6;
    .edit-row{
      display:flex;
      flex-direction:row;
      align-items: center;
      justify-content: center;
      align-content: center;
      .el-form-item{
        display:flex;
        flex-direction:row;
        align-items: center;
        margin-bottom:26px;
        &.select-input{
          margin-right:43px;
          .el-select{
            .el-input__inner{
              width: 370px;
              height: 46px;
              border: 1px solid #CCCCCC;
              border-radius: 4px;
              background:transparent;
            }
          }
        }
        &.offer-input{
          .el-input__inner{
            width: 346px;
            height: 46px;
            border: 1px solid #CCCCCC;
            border-radius: 4px;
            background:transparent;
          }
        }
        .el-form-item__label{
          width:92px;
          font-size:16px;
          color:#999999;
          text-align:left;
        }
      }
    }
    .upload-input{
      display:flex;
      flex-direction:row;
      .el-form-item__label{
        width:92px;
        font-size:16px;
        color:#999999;
        text-align:left;
      }
      .el-form-item__content{
        display:flex;
        flex-direction:row;
        .upload-input-inner{
          position: relative;
          width:70px;
          height:70px;
          border:1px dashed #CCCCCC;
          border-radius:4px;
          display:flex;
          flex-direction:row;
          align-items:center;
          justify-content:center;
          align-content:center;
          align-content: flex-end;
          .inner-icon{
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            width: 24px;
            height: 24px;
            background-size: 100%;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(~@/assets/edit_uploading_icon.png);
          }
          .inner-text{
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            width:70px;
          }
        }
        .inner-tip{
          margin-left:19px;
          margin-top:60px;
          line-height:1.2em;
          font-size: 12px;
          color:#999;
        }
      }
    }
    .edit-sure-button-wrap{
      margin-top:30px;
      position:relative;
      height:46px;
      line-height:46px;
      .edit-sure-button{
        position:absolute;
        left:92px;
        width:100px;
        height:46px;
        background:#EC4040;
        border-radius:4px;
        font-size:16px;
        color:#FFF;
      }
    }
    
  }
  .tools-box{
    position: relative;
    width: 100%;
    margin-top: 40px;
  }
  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .page-nav-items {
      .page-parentname {
        color: rgba(153, 153, 153, 1);
      }
    }
  }
  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
  }
  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .project-name-cell {
    position: relative;
    width: 156px;
    margin-right: 20px;
  }
  .id-secret-cell {
    position: relative;
    width: 187px;
    margin-right: 25px;
  }
  .status-cell {
    position: relative;
    width: 65px;
    margin-right: 35px;
  }
  .white-cell {
    position: relative;
    width: 96px;
    margin-right: 30px;
  }
  .creattime-cell {
    position: relative;
    width: 83px;
    margin-right: 38px;
  }
  .operate-cell {
    position: relative;
    width: 203px;
    text-align: center;
    div{
      font-size: 16px;
      color: #EC4040;
      &.operate-edit{
        margin-right:24px;
      }
    }
  }
  .table-header-box {
    position: relative;
    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 24px;
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
  }
  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    height: 100px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 24px;
    &:nth-child(2n) {
      background: #f6f6f6;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
    }
    .operate-cell {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ec4040;
      line-height: 16px;
      div {
        cursor: pointer;
      }
    }
    .white-cell {
      text-align: center;
    }
  }
  .tasktype-cell {
    position: relative;
    width:20%;
  }
  .projecttype-cell {
    position: relative;
    width: 20%;
    text-align: center;
  }
  .project-yusuan-cell {
    position: relative;
    width: 20%;
    text-align: center;
  }
  .task-publishtime-cell {
    position: relative;
    width: 20%;
    text-align: center;
  }
  .operate-cell {
    position: relative;
    width: 20%;
    text-align: center;
  }
  .datalist-row {
    height: 100px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 24px;
    &:nth-child(2n) {
      background: #f6f6f6;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      &.color4001{
        color: #000;
      }
      &.color4002{
        color: #0072ff;
      }
      &.color4003{
        color: #EC4040;
      }
    }
    .projecttype-cell,
    .project-yusuan-cell,
    .demand-status-cell,
    .demand-publishtime-cell {
      text-align: center;
    }
    .white-cell {
      text-align: center;
    }
  }
}
</style>